import React, { useCallback, useMemo, useState } from 'react';
import { Text, Alert, ListItem, UnorderedList } from '@televet/kibble-ui';
import { useSidePanelSearch } from 'shared/components/SidePanel/components/SearchPanel/state/providers/SearchPanelProvider';
import { INotificationErrorTextProps } from '../..';

interface ChannelWarningBannerProps {
  warnings: INotificationErrorTextProps[];
  close: () => void;
}

export const ChannelWarningBanner = ({ warnings, close }: ChannelWarningBannerProps): JSX.Element => {
  const [showDetails, setShowDetails] = useState(false);

  const { viewClinicPetParent } = useSidePanelSearch();

  const openSidePanel = useCallback(
    (parentId: string): void => {
      if (!parentId) {
        return;
      }
      viewClinicPetParent({ clinicPetParentId: parentId });
    },
    [viewClinicPetParent],
  );

  const details = useMemo(() => {
    return (
      <UnorderedList>
        {warnings.map((entry, entryIndex) => {
          return entry.reason.map((warningText, ind) => (
            <ListItem key={`${entryIndex}-warning-${ind}`}>
              <Text
                size="sm"
                cursor="pointer"
                as="span"
                textDecoration="underline"
                onClick={(): void => openSidePanel(entry?.parentId || '')}
              >
                {entry.title}:
              </Text>{' '}
              <Text as="span" size="sm">
                {warningText}
              </Text>
            </ListItem>
          ));
        })}
      </UnorderedList>
    );
  }, [warnings, openSidePanel]);

  return (
    <Alert
      mx="1"
      mt="1"
      status="warning"
      title={
        <Text size="sm" fontWeight="bold">
          {warnings[0].headers[0]}
        </Text>
      }
      buttonProps={{
        buttonText: `${showDetails ? 'Hide' : 'Show'} Details`,
        onClick: (): void => setShowDetails((toggle) => !toggle),
      }}
      onClose={close}
      description={showDetails ? details : null}
    />
  );
};
